import { render, staticRenderFns } from "./NLTransactionsN.vue?vue&type=template&id=66ec58b3&"
import script from "./NLTransactionsN.vue?vue&type=script&lang=js&"
export * from "./NLTransactionsN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports